export interface HttpResponse<T> extends Response {
  parsedBody?: T;
}

export async function http<T>(request: RequestInfo): Promise<HttpResponse<T>> {
  const response: HttpResponse<T> = await fetch(request);
  let errorMessage: string = '';
  try {
    const isJsonResponse = response?.headers
      ?.get('content-type')
      ?.includes('application/json');
    if (isJsonResponse) {
      const res = await response.json();
      response.parsedBody = res;
      errorMessage = res?.message || 'Unknown error';
    } else {
      errorMessage = (await response.text()) || 'Unknown error';
    }
  } catch (ex) {
    console.error('Error parsing response:', ex);
  }
  if (!response.ok) {
    const errorJson = {
      url: (request as Request)?.url,
      serverMessage: errorMessage,
      status: response?.status,
      errorMessage: response?.statusText,
      errorStack: new Error(response?.statusText)?.stack,
    };
    console.log(errorJson);
    throw {
      status: response.status,
      error: new Error(response.statusText),
      parsedBody: response.parsedBody,
    };
  }
  return response;
}
